const layoutData = (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_LAYOUT_DATA':
      return {
        ...state,
        [action.appname]: action.data,
      };

    default:
      return state;
  }
};

export default layoutData;
